import { render } from "./DetailRiwayatTutupOutletModal_c.vue?vue&type=template&id=13e76bec&scoped=true"
import script from "./DetailRiwayatTutupOutletModal_c.vue?vue&type=script&lang=js"
export * from "./DetailRiwayatTutupOutletModal_c.vue?vue&type=script&lang=js"

import "./DetailRiwayatTutupOutletModal_c.vue?vue&type=style&index=0&id=13e76bec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13e76bec"

export default script